export default __webpack_public_path__ + "static/media/card1.2fe2b050.svg";